import { endpoints } from './endpoints'
import { MainRepository } from './main.repository'

export const repositories = (gaApp) => ({
  main: new MainRepository(gaApp, endpoints),
})
